import React, { useEffect } from 'react';
import { Dialog, Size } from '@lux/dialog';
import { Present } from '@lux/graphics';
import { TitlePreset, Color } from '@lux/title';
import { Translate, TranslateScope } from '@pegasus/translation';
import { track } from '../../helpers';
import { Heading, Wrapper } from './styles';
import { SingleUserContent } from './single-user-content';
import { WithSwitchAccountContent } from './with-switch-account-content';
const noop = () => { };
export const NewsletterSubscriptionDialog = ({ isShown, hide, onSubscribe = noop, hasSecondaryAuth = false, onLogout = noop, email, firstName = '', closable = true, }) => {
    useEffect(() => {
        if (isShown) {
            track('newsletter_prompt_visible');
        }
    }, [isShown]);
    const handleSwitchAccount = () => {
        track('newsletter_prompt_change');
        onLogout();
    };
    const handleSubscribe = () => {
        track('newsletter_prompt_subscribe');
        onSubscribe();
    };
    return (React.createElement(TranslateScope, { path: "newsletterDialog" },
        React.createElement(Dialog, { isShown: isShown, size: Size.S, sizeSm: Size.L, sizeMd: Size.S, closeIcon: closable, closeDialog: () => {
                track('newsletter_prompt_close');
                hide();
            }, closeLabel: "Close", mobileFullScreen: hasSecondaryAuth, rawDialogBody: true },
            React.createElement(Wrapper, { closable: closable },
                React.createElement(Present, null),
                " ",
                React.createElement(Heading, { color: Color.dark, preset: TitlePreset.S },
                    React.createElement(Translate, { message: "saveOnFirstOrder" }),
                    hasSecondaryAuth ? ` ${firstName}` : ''),
                hasSecondaryAuth ? (React.createElement(WithSwitchAccountContent, { onSubscribe: onSubscribe, onSwitchAccount: handleSwitchAccount, email: email })) : (React.createElement(SingleUserContent, { onSubscribe: handleSubscribe }))))));
};
//# sourceMappingURL=component.js.map